module.exports = __webpack_public_path__ + "static/media/Python.3387d6d4.png";